import { EventEmitter, Injectable } from '@angular/core';
export var BsDropdownState = (function () {
    function BsDropdownState() {
        var _this = this;
        this.direction = 'down';
        this.isOpenChange = new EventEmitter();
        this.isDisabledChange = new EventEmitter();
        this.toggleClick = new EventEmitter();
        this.dropdownMenu = new Promise(function (resolve) {
            _this.resolveDropdownMenu = resolve;
        });
    }
    BsDropdownState.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDropdownState.ctorParameters = function () { return []; };
    return BsDropdownState;
}());
//# sourceMappingURL=bs-dropdown.state.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/dropdown/bs-dropdown.state.js
// module id = 132
// module chunks = 13